import axios from 'axios'
import Swal from 'sweetalert2'
export const baseUrl = "https://landing.benice.ir"
export const imgBaseUrl = "https://landing.benice.ir/IO/"
export const imgBaseUrl2 = "https://landing.benice.ir/"
// const header = { 'Content-Type': 'application/json; charset=utf-8' }
// const getAuthHeader = () => {
//     try {
//         let token = localStorage.getItem('token');
//         if (token) {
//             token = token.replace(/"/g, '');
//            return { 'Authorization': 'Bearer ' + token };
//         }
//         else{
//             window.location.replace('login')
//         }

//     } catch (error) {

//     }
// }
const api = async (method, url, params = {}, additionalHeaders = null) => {
    // additionalHeaders:{ preventShowError : boolean };

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json; charset=utf-8");
    // myHeaders.append("Cookie", "JSESSIONID=node072dec6r1f87vg7gwqo6l9urd298.node0");

    if (method == "get") {
        // url += "?";
        // var paramsObj = Object.keys(params).map((key) => [(key), params[key]]);
        // paramsObj.forEach((element, index) => {
        //     url += `${index}=!${element}&`;
        // });
        // let raw = JSON.stringify(params);
        // let requestOptions = {
        //     method: 'GET',
        //     headers: myHeaders,
        //     body: raw,
        //     redirect: 'follow'
        // };
        // return await fetch(`${baseUrl}${url}`, requestOptions);

        var data = JSON.stringify(params);

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${baseUrl}${url}`,
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                //   'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: data
        };
        axios.defaults.withCredentials = true;
        return new Promise(async (resolve, reject) => {

            let result = null;
            let response = await axios(config).then(res => {
                result = res;
            }).catch(error => {
                if (error && error.response && error.response.status == 401) {
                    // window.location.replace('/pages/login');
                }
                else {
                    result = error.response;
                    if (!additionalHeaders || additionalHeaders.preventShowError !== true) {
                        // store.dispatch({ type: "SET_ERRORS", payload: { errors: [error.response.data] } });
                    }
                }
                reject(error);
            })
            resolve(result);
        });
    }
    if (method == "post") {
        // let raw = JSON.stringify(params);
        // let requestOptions = {
        //     method: 'POST',
        //     headers: myHeaders,
        //     body: raw,
        //     redirect: 'follow'
        // };        
        // return await fetch(`${baseUrl}${url}`, requestOptions);

        var data = JSON.stringify(params);

        var config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseUrl}${url}`,
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                //   'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: data
        };
        axios.defaults.withCredentials = true;
        return new Promise(async (resolve, reject) => {

            let result = null;
            let response = await axios(config).then(res => {
                result = res;
            }).catch(error => {
                // Swal.fire({
                //     icon: "warning",
                //     title: "لطفا دوبار تلاش نمایید",
                //     showConfirmButton: false,
                //     timer: 1500
                // })

                reject(error);
            })
            resolve(result);
        });
    }
    // if you need to pass some params in url (post method) use 
    // method = "postQuery" and your params should be like this : 
    // params = {query : { ... : ...} , raw : { ... : ...}}
    if (method == "postQuery") {
        url += "?";
        var paramsObj = Object.keys(params.query).map((key) => [(key), params.query[key]]);
        paramsObj.forEach((element, index) => {
            url += `${element[0]}=${element[1]}&`;
        });
        // return await axios.post(url, params.raw, { headers: { ...defaultHeaders() } });
        let raw = JSON.stringify(params);
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        return await fetch(`${baseUrl}${url}`, requestOptions);
    }
};



//category
export const getCategories = async (params) => {
    return api("get", `/Category/GetList`, params);
}

//product
export const getProductsBySearch = async (params) => {
    return api("post", `/Product/Search`, params);
}
export const getProductsById = async (params) => {
    return api("get", `/Product/${params}`);
}
export const getShopBySearch = async (params) => {
    return api("post", `/OrderGetway/Search`, params);
}
//comment
export const getCommentBySearch = async (params) => {
    return api("post", `/ProductUserComment/Search`, params);
}
export const getCreateComment = async (params) => {
    return api("post", `/ProductUserComment/Create`, params);
}
//news and blos
export const getBlogsAndNewsBySearch = async (params) => {
    return api("post", `/WeblogAndNews/Search`, params);
}

//customers
export const getCustomer = async (params) => {
    return api("post", `/Company/Search`, params);
}

//category
export const getCategory = async (params) => {
    return api("post", `/ProductGroup/Search`, params);
}
//FoundUs
export const getFoundUs = async (params) => {
    return api("post", `/FoundUs/Search`, params);
}
//aboutUs
export const getAboutUs = async (params) => {
    return api("post", `/AboutUs/Search`, params);
}

//Department
export const getDepartment = async (params) => {
    return api("post", `/Department/Search`, params);
}

//Department
export const getPopup = async (params) => {
    return api("post", `/Popup/Search`, params);
}
//Department
export const getIntroduction = async (params) => {
    return api("post", `/Introduction/Search`, params);
}

//Subject
export const getSubject = async (params) => {
    return api("post", `/Subject/Search`, params);
}

//contact
export const getContact = async (params) => {
    return api("post", `/Contact/Search`, params);
}
export const getCreateContactUs = async (params) => {
    return api("post", `/ContactUs/Create`, params);
}

//Branch
export const getBranch = async (params) => {
    return api("post", `/Branch/Search`, params);
}

//Gender
export const getGender = async (params) => {
    return api("post", `/Gender/Search`, params);
}
//CreateHire 
export const getCreateHire = async (params) => {
    return api("post", `/Hire/Create`, params);
}
//getImg
export const getImage = async (params) => {
    return api("get", `/IO/${params}`
    );
}

export const getBlogById = async (params) => {
    return api("get", `/WeblogAndNews/${params}`);
}


//banner
export const SearchBanner = async (params) => {
    return api("get", `/Banner/${params.slug}`);
};

